/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql, useMutation } from '@apollo/client';

export const useUpdateSubscriptionMail = () => {
    const updateSubsRequest =  {}
    const UPDATE_SUBSCRIPTIONS_GQL = gql`
        mutation UpdateSubscriptions($updateSubsRequest: UpdateSubscriptionsRequest!) {
            updateSubscriptions(updateSubsRequest: $updateSubsRequest)
        }
    `

    const [updateMutation] = useMutation(UPDATE_SUBSCRIPTIONS_GQL,{context:{clientName:"notification"}});
    
      return {
        updateMutation:async (updateSubscriptionObject) => {
        return await updateMutation({variables:{"updateSubsRequest":updateSubscriptionObject}})
    }
    };
}